import { createTheme, alpha } from '@mui/material/styles'

// Brand palette — Guide de style UI : Palette Immobilière & Financière
export const palette = {
  background: '#4A2A1F', // fond-page — arrière-plan principal
  sidebar: '#3A1F17', // fond-carte — réutilisé pour la sidebar
  sidebarActive: '#5C3324', // fond-badge — élément de nav actif
  card: '#3A1F17', // fond-carte — conteneurs d'information
  badge: '#5C3324', // fond-badge — badges, pastilles, vignettes
  text: '#F8ECE2', // texte-primaire — titres, valeurs
  textSecondary: '#D8B8A8', // texte-secondaire — sous-titres
  textMuted: '#C19A86', // texte-muted — labels, aide, adresses
  textBadge: '#E0B89D', // texte-badge — texte dans les badges
  actionPrimary: '#F0D9C8', // action-primaire — boutons principaux
  actionText: '#4A2A1F', // action-texte — texte sur bouton primaire
  positive: '#7FBF9E', // positif — cash-flow / marges positifs
  negative: '#D36C6C', // negatif — cash-flow / marges négatifs
  border: '#8A6A56', // bordure — contours pointillés, séparateurs
  accent: '#F0D9C8', // warm accent (charts, focus)
}

const theme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: palette.background,
      paper: palette.card,
    },
    primary: {
      main: palette.actionPrimary,
      contrastText: palette.actionText,
    },
    secondary: {
      main: palette.accent,
      contrastText: palette.actionText,
    },
    text: {
      primary: palette.text,
      secondary: palette.textSecondary,
    },
    divider: alpha(palette.border, 0.25),
    success: { main: palette.positive },
    error: { main: palette.negative },
  },
  shape: { borderRadius: 16 },
  typography: {
    fontFamily: '"Inter Variable", "Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h4: { fontWeight: 700, letterSpacing: 0.2 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 600, fontSize: '1.05rem' },
    overline: { letterSpacing: 1, opacity: 0.75 },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none' },
      },
    },
    MuiCard: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: {
          backgroundColor: palette.card,
          borderRadius: 20,
          border: `1px solid ${alpha(palette.border, 0.35)}`,
          boxShadow: `0 0 0 1px ${alpha(palette.actionPrimary, 0.04)}, 0 4px 20px rgba(0,0,0,0.32), inset 0 1px 0 rgba(255,255,255,0.03)`,
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: { padding: 20, '&:last-child': { paddingBottom: 20 } },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: { backgroundColor: palette.sidebar, backgroundImage: 'none' },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: { backgroundColor: palette.sidebar, border: 'none' },
      },
    },
    MuiTextField: {
      defaultProps: { size: 'small', fullWidth: true },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          backgroundColor: 'rgba(0,0,0,0.18)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 999, textTransform: 'none', fontWeight: 600, paddingInline: 20 },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          fontWeight: 600,
        },
      },
      variants: [
        {
          props: { color: 'default' },
          style: {
            backgroundColor: palette.badge,
            color: palette.textBadge,
          },
        },
      ],
    },
    MuiToggleButton: {
      styleOverrides: {
        root: { textTransform: 'none', fontWeight: 600, borderColor: alpha(palette.border, 0.3) },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: { borderColor: alpha(palette.border, 0.3), borderStyle: 'dashed' },
      },
    },
  },
})

export default theme
